export const GET_TRANSACTIONS = 'user/get_transactions';
export const GET_TRANSACTIONS_COMPLETED = 'user/get_transactions_COMPLETED';
